import { Trans, useTranslation } from 'react-i18next';
import { useOpenLiveChat } from '@hub/hooks';
import { Button, Stack, Typography } from '@monorepo/nova-ui';

export const NoMoreRetries = ({ isLoading }: { isLoading: boolean }) => {
  const { t } = useTranslation(['mailConfirmationNova']);

  const openLiveChat = useOpenLiveChat({ flow: 'no-more-retries' });

  return (
    <Stack textAlign="center" gap={5}>
      <Typography variant={'h3'} textAlign="center" mt={6}>
        {t('mailConfirmationNova:protecting_account_title')}
      </Typography>
      <Stack textAlign="center" gap={5}>
        <Typography textAlign="center">
          {t('mailConfirmationNova:you_ve_used_all_your_attempts')}
        </Typography>
        <Typography textAlign="center">
          <Trans
            ns="mailConfirmationNova"
            i18nKey="contact_support_to_protect"
            components={{ br: <br /> }}
          />
        </Typography>
      </Stack>
      <Stack direction={'row'} justifyContent={'center'}>
        <Button
          size={'lg'}
          variant={'outlined'}
          loading={isLoading}
          onClick={openLiveChat}
        >
          {t('mailConfirmationNova:contact_support')}
        </Button>
      </Stack>
    </Stack>
  );
};
